jQuery($ => {
    if ($(".m-cancellation-form__button[disabled]")[0]) {
        $('.m-cancellation-form .a-select').on('chooseSelectOption', function () {
            $(this).closest('.m-cancellation-form').find('.m-cancellation-form__button').removeAttr('disabled');

            if ($(this).find('.a-select__value').text() == 'Other') {
                $('.m-cancellation-form__textarea').show();
            } else {
                $('.m-cancellation-form .a-textarea').val('');
                $('.m-cancellation-form__textarea').hide();
            }
        });
    }
});